<template>
	<div>
		<base-header class="pb-6 bg-light">
			<b-row align-v="center" class="py-4">
				<b-col cols="7" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Search</h6>
				</b-col>
				<b-col cols="5" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
			<!-- Card stats -->
			<b-row>
				<b-col xl="12">
					<search-criteria />
				</b-col>
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<search-result></search-result>
		</b-container>
	</div>
</template>
<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import SearchCriteria from "./SearchCriteria";
import searchDashboardService from "@/common/api-services/search-dashboard-service";
import SearchResult from "./SearchResult";
import configDirective from "../../../common/directive/config-directive";

export default {
	components: {
		SearchResult,
		SearchCriteria,
		RouteBreadCrumb,
	},
	data() {
		return {};
	},
	mounted: function () {
		document.title = "Search";

		let config = configDirective.getConfigData();
		if (!config || config.length < 25) {
			this.$router.push({name: "login"});
			sessionStorage.clear();
		}

		this.getSimTypeFunc();
		this.getStateFunc();

		this.$root.$on("submitSearchFunc", res => {
			if (res) {
				let {start, length, filter} = res;
				this.getSearchResultFunc(start, length, filter);
			}
		});

	},
	methods: {
		getSimTypeFunc() {
			let data = [];
			data.push({simtype: "All"});
			searchDashboardService.getSimType().then(res => {
				if (res) {
					data.push(res);
				}
				this.$root.$emit("getSimType", data);
			});
		},

		getStateFunc() {
			searchDashboardService.getStateType().then(res => {
				let data = [];
				data.push({State: "All", value: null});
				if (res) {
					res.map(item => {
						data.push(item);
					});
				}
				this.$root.$emit("getStateType", data);
			});
		},

		async getSearchResultFunc(start, length, filter) {
			// console.log(filter)
			let {fStartIMSI, fEndIMSI, fSimType, fIccid, fMsisdn, fState} = filter;
			await searchDashboardService.getSearchResultByFilter(fStartIMSI, fEndIMSI, fSimType, fIccid, fMsisdn, fState, start, length, sort).then(res => {
				this.$root.$emit("getSearchResult", {res: res, filter: filter});
			})
			.catch(err => {
				// console.log(err);
				this.$toast.error(err);
			});
			// await searchDashboardService.getSearchResult(start, length, filter).then(res => {
			// 	this.$root.$emit("getSearchResult", {res: res, filter: filter});
			// });
		},
	},
};
</script>
